import { render, staticRenderFns } from "./BannerAlert.vue?vue&type=template&id=511f084e&scoped=true&"
import script from "./BannerAlert.vue?vue&type=script&lang=ts&"
export * from "./BannerAlert.vue?vue&type=script&lang=ts&"
import style0 from "./BannerAlert.vue?vue&type=style&index=0&id=511f084e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511f084e",
  null
  
)

export default component.exports